import script from "./NotificationsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsList.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsList.vue?vue&type=style&index=0&id=11a87785&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a87785"]])

export default __exports__